import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "admin-section" }
const _hoisted_2 = {
  target: "_blank",
  href: "https://memories.gallery/troubleshooting/#trigger-compatibility-mode"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcNoteCard = _resolveComponent("NcNoteCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$options.title), 1),
    _createElementVNode("p", null, [
      _createVNode(_component_NcNoteCard, {
        type: _ctx.isHttps ? 'success' : 'error'
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.isHttps
            ? _ctx.t('memories', 'HTTPS is enabled')
            : _ctx.t(
                'memories',
                'You are accessing this page over an insecure context. Several browser APIs are not available, which will make Memories very slow. Enable HTTPS on your server to improve performance.',
              )), 1)
        ]),
        _: 1
      }, 8, ["type"]),
      _createVNode(_component_NcNoteCard, {
        type: _ctx.httpVerOk ? 'success' : 'warning'
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.httpVerOk
            ? _ctx.t('memories', 'HTTP/2 or HTTP/3 is enabled')
            : _ctx.t('memories', 'HTTP/2 or HTTP/3 is strongly recommended ({httpVer} detected)', { httpVer: _ctx.httpVer })), 1)
        ]),
        _: 1
      }, 8, ["type"])
    ]),
    _createElementVNode("p", null, [
      _createVNode(_component_NcNoteCard, {
        type: _ctx.config['memories.db.triggers.fcu'] ? 'success' : 'error'
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.config['memories.db.triggers.fcu']
            ? _ctx.t('memories', 'Database triggers are set up correctly.')
            : _ctx.t('memories', 'Database triggers not set up; {m} mode in use.', { m: 'trigger compatibility' })) + " ", 1),
          _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
          (!_ctx.config['memories.db.triggers.fcu'])
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'See the documentation for information on how to resolve this.')) + " ", 1),
                _createElementVNode("a", _hoisted_2, _toDisplayString(_ctx.t('memories', 'External Link')), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["type"])
    ])
  ]))
}